import { Box, Chip } from '@mui/material';
import { gridStyles } from 'customer-management/styles';
import { UseTableCellProps } from 'react-table';
import { CustomerManagementGridItem } from 'shared/types';

export function StatusColumn(props: UseTableCellProps<CustomerManagementGridItem>) {
  const {
    row: {
      original: { isDeleted, isMarkedForDeletion },
    },
  } = props;
  const statusLabel = isDeleted ? 'Deleted' : isMarkedForDeletion ? 'Marked for deletion' : ' Active ';
  const statusColor = isDeleted ? 'error' : isMarkedForDeletion ? 'warning' : 'success';

  return (
    <Box sx={gridStyles}>
      <Chip label={statusLabel} color={statusColor} variant='outlined' />
    </Box>
  );
}
